import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SizingConfirmDialogComponent } from './sizing-confirm-dialog.component';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [
    SizingConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    MatProgressBarModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    MatSelectModule
  ],
  exports: [
    SizingConfirmDialogComponent
  ]
})
export class SizingConfirmDialogModule { }

